/**
 * Thẻ thống kê dashboard admin — số liệu format vi-VN và theme màu theo loại.
 */
const formatStatValue = (value) => new Intl.NumberFormat('vi-VN').format(value ?? 0);

const STAT_THEMES = {
  default: {
    iconBg: '#eff6ff',
    iconColor: '#2563eb',
    accent: '#2563eb',
  },
  success: {
    iconBg: '#ecfdf5',
    iconColor: '#059669',
    accent: '#059669',
  },
  info: {
    iconBg: '#f0fdfa',
    iconColor: '#0f766e',
    accent: '#0f766e',
  },
  warning: {
    iconBg: '#fffbeb',
    iconColor: '#d97706',
    accent: '#d97706',
  },
  muted: {
    iconBg: '#f3f4f6',
    iconColor: '#6b7280',
    accent: '#6b7280',
  },
  urgent: {
    iconBg: '#fff0f3',
    iconColor: '#e31c5f',
    accent: '#e31c5f',
  },
};

export const DashboardStatCard = ({ label, value, description, icon, theme = 'default' }) => {
  const colors = STAT_THEMES[theme] || STAT_THEMES.default;

  return (
    <article className="admin-dashboard-stat" style={{ '--stat-accent': colors.accent }}>
      <div
        className="admin-dashboard-stat-icon"
        style={{ background: colors.iconBg, color: colors.iconColor }}
        aria-hidden="true"
      >
        {icon}
      </div>
      <div className="admin-dashboard-stat-body">
        <span className="admin-dashboard-stat-label">{label}</span>
        <strong className="admin-dashboard-stat-value">{formatStatValue(value)}</strong>
        {description && <p className="admin-dashboard-stat-desc">{description}</p>}
      </div>
    </article>
  );
};
